import _ from 'lodash';
import { TravelTypes } from '../constants';
import formatPriceRequest from './formatPriceRequest';
import getPriceBreakdownKey from './getPriceBreakdownKey';

const getPriceBreakdownsFromBrochureTrip = (trip) => {
  const priceBreakdowns = {};
  try {
    const cruiseSegment =
      trip &&
      trip.tripSegments &&
      _.find(trip.tripSegments, (ts) => ts.mode === TravelTypes.cruise);
    if (cruiseSegment && cruiseSegment.itinerary && cruiseSegment.itinerary.cabinCategories) {
      cruiseSegment.itinerary.cabinCategories.forEach((cabin) => {
        if (cabin.cabinCategories) {
          cabin.cabinCategories.forEach((category) => {
            if (category.rateOptions) {
              category.rateOptions.forEach((rateOption) => {
                if (rateOption.pricing) {
                  const key = getPriceBreakdownKey(
                    formatPriceRequest({
                      itineraryId: cruiseSegment.itinerary.itineraryDetail.itineraryId,
                      cruiseLineId: cruiseSegment.itinerary.itineraryDetail.cruiseLine.cruiseLineId,
                      cabinCategoryCode: category.cabinCategoryCode,
                      rateOptionCode: rateOption.rateOptionCode,
                      staterooms: [cabin.searchInput],
                    }),
                  );
                  priceBreakdowns[key] = [rateOption.pricing];
                }
              });
            }
          });
        }
      });
    }
  } catch (ex) {
    console.error(ex);
  }
  return priceBreakdowns;
};

export default getPriceBreakdownsFromBrochureTrip;
